import { GET_CONTACT_LENS_BY_SLUG } from "../../operations/queries/operations/queries/get-contact-lens-by-slug.js";
const getContactLensBySlug = async ({ client, slug, locale }) => {
  const queryResult = await client.query({
    query: GET_CONTACT_LENS_BY_SLUG,
    variables: { slug },
    context: { headers: { "Accept-Language": locale } }
  });
  return queryResult;
};
export {
  getContactLensBySlug
};
//# sourceMappingURL=getContactLensBySlug.js.map
